import React from 'react';
import { Helmet } from 'react-helmet-async';
import Header from '../inc/header';
import Footer from '../inc/footer';

function CodeOfConduct() {
    return (
        <>
            <Helmet>
                <title>Code of Conduct | Gulf Strategic Partners Co.</title>
            </Helmet>

            <style>
                {`
                /* ====== General Typography ====== */
                #content_section p, ul, h1, h4 {
                    text-align: justify !important;
                    color: #000;
                }

                .service-description {
                    text-align: justify !important;
                    color: #000;
                    line-height: 1.8;
                }

                .service-description ul li::marker {
                    color: #E6178B !important;
                }

                .service-description h4 {
                    color: #2d3033;
                    font-weight: 700;
                    margin-top: 30px;
                    margin-bottom: 15px;
                }

                .service-description p, .service-description ul {
                    margin-bottom: 15px;
                }

                /* ====== Page Header ====== */
                .page-header {
                    background-size: cover;
                    background-position: center;
                    color: #fff;
                    padding: 100px 0;
                }

                .page-header h1 {
                    font-weight: 700;
                    color: #fff;
                }

                /* ====== Mobile Optimization ====== */
                @media (max-width: 768px) {
                    .page-header {
                        padding: 60px 0;
                    }
                }
                `}
            </style>

            <Header />

            <main role="main" className="main">
                {/* ======= PAGE HEADER ======= */}
                <section
                    className="page-header page-header-modern page-header-background overlay overlay-color-dark overlay-show overlay-op-7"
                    style={{
                        backgroundImage: "url('/assets/img/slides/page-header-services.jpg')",
                    }}
                >
                    <div className="container">
                        <div className="row mt-5">
                            <div className="col-md-12 align-self-center text-center">
                                <h1 className="text-10 fw-bold">
                                    <strong>Code of Conduct</strong>
                                </h1>
                            </div>
                        </div>
                    </div>
                </section>

                {/* ======= CONTENT SECTION ======= */}
                <div className="container py-5">
                    <div className="row justify-content-center">
                        <div className="col-lg-10 col-md-12">
                            <div className="service-description">

                                <h4>1. Introduction</h4>
                                <p>
                                    At <strong>Gulf Strategic Partners Co. (GSP)</strong>, we are committed to conducting our business with integrity, professionalism, and respect.
                                    This Code of Conduct serves as a guide to the standards we uphold in our work and interactions with clients, partners, employees, and the wider community.
                                </p>

                                <h4>2. Integrity and Ethical Behavior</h4>
                                <p>All employees and representatives of GSP must:</p>
                                <ul>
                                    <li>Act honestly and fairly in all dealings.</li>
                                    <li>Avoid conflicts of interest.</li>
                                    <li>Never engage in bribery, corruption, or unethical conduct.</li>
                                    <li>Maintain confidentiality of sensitive information.</li>
                                    <li>Ensure truthful communication and documentation.</li>
                                </ul>

                                <h4>3. Compliance with Laws and Regulations</h4>
                                <p>We operate in full compliance with:</p>
                                <ul>
                                    <li>Local and international laws.</li>
                                    <li>Industry-specific regulations.</li>
                                    <li>Health, safety, and environmental standards.</li>
                                    <li>Anti-bribery and anti-corruption policies.</li>
                                </ul>

                                <h4>4. Workplace Conduct and Respect</h4>
                                <p>
                                    GSP fosters a respectful, inclusive, and professional workplace. We do not tolerate:
                                </p>
                                <ul>
                                    <li>Discrimination or harassment.</li>
                                    <li>Any form of workplace abuse or intimidation.</li>
                                    <li>Unsafe behaviour or working conditions.</li>
                                </ul>
                                <p>All team members are expected to treat others with respect and dignity.</p>

                                <h4>5. Health, Safety, and Environment (HSE)</h4>
                                <p>We are committed to:</p>
                                <ul>
                                    <li>Maintaining safe and healthy working environments.</li>
                                    <li>Preventing accidents and environmental harm.</li>
                                    <li>Complying with all HSE laws and best practices.</li>
                                    <li>Empowering employees to prioritize safety at all times.</li>
                                </ul>

                                <h4>6. Confidentiality and Data Protection</h4>
                                <ul>
                                    <li>Protect sensitive company and client information.</li>
                                    <li>Handle data responsibly and lawfully.</li>
                                    <li>Respect intellectual property and proprietary data.</li>
                                </ul>

                                <h4>7. Reporting Violations</h4>
                                <p>
                                    Employees are encouraged to report any unethical or unlawful conduct. GSP ensures:
                                </p>
                                <ul>
                                    <li>Confidential and secure reporting channels.</li>
                                    <li>No retaliation against whistleblowers.</li>
                                    <li>Prompt and fair investigation of all concerns.</li>
                                </ul>

                                <h4>8. Our Commitment</h4>
                                <p>
                                    At Gulf Strategic Partners, we strive for excellence in every aspect of our business.
                                    This Code reflects our values and our dedication to ethical, responsible, and sustainable business practices.
                                </p>
 
                            </div>
                        </div>
                    </div>
                </div>
            </main>

            <Footer />
        </>
    );
}

export default CodeOfConduct;
